export const environment = {
  production: false,
  apiBaseUrl: 'http://178.105.189.197:3000',
  baseUrl: 'http://localhost:4200',
  stripePublicKey: 'pk_test_51TbeX4Du7EteCotyw9KtNQSl725vCS2ZkGXgdyfQ3f7NYfMRlDH2MyuJTumY4SJXXXD8VBgs36meEBxGcn6pjgPf00LbtXPHq0',
  stripeSuccessUrl: 'http://localhost:4200/success',
  stripePaymentLinkUrl: 'https://buy.stripe.com/test_eVq8wP5oEaqM0Pod1G1B602',
  contentGistUrl: 'https://gist.githubusercontent.com/oscartmxpgit/7e493167502358088680e858229c5103/raw/baluarte-content.json',
  supportEmail: 'hola@baluarte.tech'
};